import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["warning"]

  reset() {
    this.warningTargets.forEach((warning) => warning.remove())
  }
}
